import axios from 'axios';
import { history } from '../store';

export const TEAM_CREATED = 'TEAM_CREATED';

const createTeam = name => (
  (dispatch) => {
    return axios.post('/api/teams/create', {
      name,
    })
      .then((response) => {
        dispatch({
          type: TEAM_CREATED,
          team: response.data.data,
        });

        return response;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      });
  }
);

export default createTeam;
